import { render, staticRenderFns } from "./VMenu.vue?vue&type=template&id=4784b938&"
import script from "./VMenu.vue?vue&type=script&lang=js&"
export * from "./VMenu.vue?vue&type=script&lang=js&"
import style0 from "./VMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports